module.exports = __webpack_public_path__ + "img/icon_cart.dd9efef1.svg";